import { Link } from "react-router-dom";
import "./Home.css";
import "./PageBackground.css";
import ProjectCard from "../components/ProjectCard";
import { getVisibleProjects } from "../data/portfolioProjects";
import { EmailIcon, LinkedInIcon, GitHubIcon } from "../components/icons";
import PillButton from "../components/PillButton";

function HomePage() {
	const projects = getVisibleProjects();

	return (
		<>
			<section
				className="PageBackground"
				style={{
					"--page-bg-image": "url(/viaduct-large.jpg)",
					"--page-bg-blur": "4px",
				}}
			>
				<div className="PageBackground__content HomePage">
					<div className="home-top-section">
						<div className="home-info">
							<h1>Nate Taylor</h1>
							<h2>Software Engineer</h2>
							<p>I am a Software Engineer, Full Stack Developer, and UX designer. I'm a lifelong learner and very detail-oriented. I firmly believe every problem is a human problem and user experience is the most important part of design and software architecture. My experience more than makes up for my absence of formal education, and has proven my worth on every software team I've been a part of, including teams where I was the only developer.</p>
						</div>
						<div className="home-profile-pic">
							<img src="nate-profile-picture.jpg" alt="Nate Taylor profile" />
							<div className="home-links" aria-label="Profile links">
								<PillButton href="mailto:nate96taylor@gmail.com" label="Email" icon={<EmailIcon width={18} height={18} />} />
								<PillButton href="https://www.linkedin.com/in/nate-online/" label="LinkedIn" external icon={<LinkedInIcon width={18} height={18} />} />
								<PillButton href="https://github.com/nateonline" label="GitHub" external icon={<GitHubIcon width={18} height={18} />} />
							</div>
						</div>
					</div>
					<div className="card-container">
						{projects.map(project => (
							<ProjectCard
								key={project.id}
								name={project.name}
								link={project.path}
								imagePath={project.image}
								tags={project.tags}
							/>
						))}
					</div>
				</div>
			</section>
		</>
	);
}

export default HomePage;
